import type { SVGProps } from 'react';
const drag = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 18 6" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18 2H0V0H18V2ZM18 4H0V6H18V4Z" fill={props.color ?? 'black'} />
  </svg>
);
export default drag;
